var map = {
	"./skin1/edit_face_highlight@3x.png": "3400",
	"./skin2/edit_face_highlight@3x.png": "ee74",
	"./skin3/edit_face_highlight@3x.png": "1fff",
	"./skin4/edit_face_highlight@3x.png": "1c0a",
	"./skin5/edit_face_highlight@3x.png": "558f",
	"./skin6/edit_face_highlight@3x.png": "e621"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a097";